import { buttons } from './buttons'
import { texts } from './texts'
import { inputs } from './inputs'
import { links } from './links'

export const themeCommons = {
  ...buttons,
  ...texts,
  ...inputs,
  ...links,
}
